// extracted by mini-css-extract-plugin
export default {"title":"styles_title__sXwv-","tooltip":"styles_tooltip__l7-B5","topText":"styles_topText__7ZJXx","bottomText":"styles_bottomText__mgmcy"};